angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsCompletePurchaseCtrl", [
  "$controller"
  "$scope"
  "ApplicationService"
  "CustomerApplicationService"
  (
    $controller
    $scope
    ApplicationService
    CustomerApplicationService
  ) ->

    $scope.page = "complete_purchase"
    $scope.stageFromState = () => $scope.page

    $scope.redirectToPosMerchant = (url) ->
      $scope.$emit "submitDisabled", true
      window.location.href = url

    $scope.$emit("customer_application:data", ApplicationService.data)
    angular.extend(
      $scope,
      $controller(
        "CustomerApplicationsMixinCtrl"
        {
          $scope: $scope
          ApplicationService
          CustomerApplicationService
        }
      )
    )

    $scope.trackVisit()
]
